import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding-top: 5rem;
`;

const TopText = styled.h2`
  color: var(--gray-900);
  font-size: 1rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
`;
const RefusedMentee: FC = () => {
  return (
    <Container>
      <TopText>Vous avez refusé le mentorat.</TopText>
    </Container>
  );
};

export default RefusedMentee;
